import * as React from "react"
import FormControl from "@material-ui/core/FormControl/FormControl"
import InputLabel from "@material-ui/core/InputLabel/InputLabel"
import Select from "@material-ui/core/Select/Select"
import MenuItem from "@material-ui/core/MenuItem/MenuItem"
import {Theme, WithStyles, Input, Chip} from "@material-ui/core"
import createStyles from "@material-ui/core/styles/createStyles"
import withStyles from "@material-ui/core/styles/withStyles"
import {compose} from "redux"
import autobind from "autobind-decorator"
import { slugify, replaceDetteWithTaux, replaceTauxWithDette } from "src/shared/utils/helpers"
import {groupBy} from 'lodash'
import { replaceNameCategory } from 'src/shared/CategoriesFilter/helpers'

const styles = (t:Theme) => createStyles({
    select: {
      minWidth: 200
    },
    root: {
      margin: `0 ${t.spacing.unit}px`
    },
    chips: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    chip: {
        margin: t.spacing.unit / 4,
    },
    itemTitle: {
      fontWeight: 'bold',
      color: t.palette.primary.main,
      pointerEvents: 'none',
    }
  });
  
  interface IProps extends WithStyles<typeof styles>{
    display: string;
    label: string;
    categoriesDispo: any;
    categories: any;
    mapName: any;
    onValueChange?: any;
  }
  
  export interface IItemcategory {
    label: string;
    value: string | boolean | number;
    clickable: boolean;
    isChecked?: boolean;
  }
  
  
  interface IState {
      items: any;
      categoriesSelected: any;
      catParentArray: any;
  }
  
  
  class SignatureCategoriesFilter extends React.Component<IProps, IState>{
  
      state = {
        items: this.renderFilterItems(),
        categoriesSelected: [],
        catParentArray: this.buildArrayCategoryWithParent(),
      };
    
      handleChange = (e) => {
          const {catParentArray} = this.state
          this.setState({ categoriesSelected: e.target.value });
          
          const temps = []
          e.target.value.map(x => {
              if(catParentArray.find(p => p.sub_category === slugify(replaceTauxWithDette(x)))){
                  temps.push(catParentArray.find(p => p.sub_category === slugify(replaceTauxWithDette(x))))
              }
          })
          
          this.props.onValueChange(this.buildObjectQuery(groupBy(temps, 'category')))
      };
      
      /*
          To build an object like
          {
              "category_produit": "change-ferme,obligations-et-titres-de-creance",
              "category_document": "contractuel,document-carde",
              "category_principale": "dette,change"
          }
      */
      @autobind
      private buildObjectQuery(catArrGrouped: any){
          const objectQuery = {}
          for (const property in catArrGrouped) {
              if (catArrGrouped.hasOwnProperty(property)) {
                  objectQuery[this.renderLabelQuery(property)] = catArrGrouped[property].map(c => c.sub_category).join()
              }
          }
          return objectQuery
      }
  
      // render object criteria label. Exp: category_produit, category_document, etc...
      @autobind
      private renderLabelQuery(nameCategory: string){
          return "category_" + slugify(nameCategory).replace(/\-+/g, '_');
      }
    
      render(){
        const { display, classes } = this.props;
        const {items, categoriesSelected} = this.state
        return (
          <FormControl className={classes.root}>
            {display && <InputLabel>{display}</InputLabel>}
            <Select
              multiple
              value={categoriesSelected}
              onChange={this.handleChange}
              className={classes.select}
              input={<Input id="select-multiple-chip" />}
              renderValue={this.renderValue}
              fullWidth={true}
            >
              {items.map((i: IItemcategory) => (
                <MenuItem key={`filter-${i.value.toString()}`} className={` ${!i.clickable ? classes.itemTitle : ''}`} value={i.value.toString()}>{replaceDetteWithTaux(i.label)}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )
      }
  
      @autobind
      private renderValue(selected: any){
          const {classes, mapName} = this.props
          return (
          <div className={classes.chips}>
              {selected.map(value => (
                  <Chip key={value} label={mapName.get(value) !== undefined ? replaceDetteWithTaux(mapName.get(value)) : '-'} className={classes.chip} />
              ))}
          </div> 
          )
      }
  
      @autobind
      private buildArrayCategoryWithParent(){ // [{sub_category, category}, {sub_category, category}, ...]
          const categoriesArray: any[] = [] as any[];
          this.props.categories.forEach(fc => {
              fc.sub_categories.sort((a, b) => a.localeCompare(b)).map(fcs => {
                  categoriesArray.push({
                      sub_category: slugify(fcs),
                      category: slugify(fc.name),
                  })
              })
          });
          return categoriesArray;
      }
    
      @autobind
      private renderFilterItems(){
        const {categories, categoriesDispo} = this.props
        const filterCategories = categories.filter(c => categoriesDispo.includes(c.name))
        filterCategories.sort((a, b) => a.name.localeCompare(b.name))
        const categoriesArray: IItemcategory[] = [];
        filterCategories.forEach(fc => {
            categoriesArray.push({
                label: replaceNameCategory(fc.name),
                value: slugify(fc.name),
                clickable: false
            })
            fc.sub_categories.sort((a, b) => a.localeCompare(b)).map(fcs => {
              categoriesArray.push({
                  label: fcs,
                  value: slugify(fcs),
                  clickable: true,
                  isChecked: false
              })
            })
        });
        return categoriesArray;
      }
}
    
  export default compose(
    withStyles(styles)
  )(SignatureCategoriesFilter );



// WEBPACK FOOTER //
// ./src/shared/CategoriesFilter/SignatureCategoriesFilter.tsx